import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "36",
  width: "50",
  viewBox: "0 0 50 36",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M5.666 0C2.5 0 0 2.5 0 5.666v24.668C0 33.5 2.5 36 5.666 36h38.668C47.5 36 50 33.5 50 30.416V5.666C50 2.5 47.5 0 44.334 0H5.666z",
    clipRule: "evenodd",
    fill: "#466ed5",
    fillRule: "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    d: "M0 4.65v7.168h50V4.65H0z",
    fill: "#2a2c30"
  }), /*#__PURE__*/_jsx("path", {
    d: "M6.834 24.916c-.167 0-.25.083-.25.25v5.5c0 .167.083.25.25.25h36.332c.167 0 .25-.083.25-.25v-5.5c0-.167-.083-.25-.25-.25H6.834z",
    clipRule: "evenodd",
    fill: "#dde2e8",
    fillRule: "evenodd"
  })]
});